import { GET_CODE_LIST } from '@/constants/codelist';

export const codeListMixin = {
    methods: {
        async getCodeList (code, defaultDisplay = 0) {
            return this.$apollo.query({
                query: GET_CODE_LIST,
                variables: {
                    code_key: code,
                    default_display: defaultDisplay
                }
            }).then(res => {
                return res.data.GetCodeList.CodeList;
            });
        }
    }
};
